import { useEffect, useState } from "react";


import { toast } from "react-toastify";
import { CompanyService } from "./Company-service";

interface Props {
    id: number;
    onchange: Function;
}
export const CompanyEditor = ({ id, onchange }: Props) => {


    const service = new CompanyService();
    const [lista, setLista] = useState<any>([]);
    const [idLista, setIDLista] = useState<number>(undefined);

    useEffect(() => {
        getCompanyCatalog();
    }, [])

    useEffect(() => {
        if (id) {
            setIDLista(id);
        }
    }, [id])
    // useEffect(() => {
    //     if (id != idLista) {
    //         onchange(idLista);
    //     }
    // }, [idLista])

    const setValue = (e: any) => {
        onchange(parseInt(e));
       //console.log(parseInt(e))
        setIDLista(e);
    }

    const getCompanyCatalog = () => {
        // service.spinON();
        service.getCompanyCatalog(idLista ? idLista : null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage);
                }
                else if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                // service.spinOFF();
            }
        )
    }
    return (
        <>
            <label>Compañia:</label>
            <select className="form-select" name="AccountantBook" value={idLista} onChange={(e) => setValue(e.target.value)}>
                <option value={undefined}>....</option>
                {lista.map((item: any, index: number) => {
                    return (
                        <option key={index} value={item.DataBeanProperties.IDCompany}>{item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}</option>
                    )
                })}
            </select>
        </>
    )
}